import { StepDocuments } from '@/components/onboarding/StepDocuments'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/carriers/$slug/driver-onboarding/documents')({
  component: DocumentsPage,
  staticData: {
    title: 'route.documents',
  },
})

function DocumentsPage() {
  const { t } = useTranslation('ui')

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{t('wizard.step.documents.title')}</h1>
      <StepDocuments />
    </div>
  )
}
